module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8011.ee5f67eb.png";